/**
 * Vee-Validate
 * Custom Rule
 *
 * @since: 2018-03-24
 * @author: kdydesign.kim
 */

import * as Rules from './customRules'

const setCustomRule = (Validator) => {
  Rules.testRule(Validator)
  Rules.isMinimum(Validator)
  Rules.isMaximum(Validator)
  Rules.isMinimumRule(Validator)
  Rules.isMaximumRule(Validator)
  Rules.isValidId(Validator)
  Rules.isValidOtpKey(Validator)
  Rules.isValidIPv4One(Validator)
  Rules.isValidIPv4(Validator)
  Rules.isValidNetmask(Validator)
  Rules.isValidIPv4IPv6(Validator)
  Rules.isValidIPv6(Validator)
  Rules.isValidMac(Validator)
  Rules.isValidMacComponent(Validator)
  Rules.isValidPrefix(Validator)
  Rules.isValidPort(Validator)
  Rules.isValidNumbers(Validator)
  Rules.isValidPasswd(Validator)
  Rules.isValidPasswdRepeat(Validator)
  Rules.isValidPasswdRepeatAllWord(Validator)
  Rules.isValidCertificatePasswd(Validator)
  Rules.isValidDdnsPasswd(Validator)
  Rules.isValidEnglishAndSpecialChar(Validator)
  Rules.isValidAnonymizerUrl(Validator)
  Rules.isValidSpaceName(Validator)
  Rules.isValidBlank(Validator)
  Rules.isValidSlashStartNoSlashEnd(Validator)
  Rules.isValidKoreaChar(Validator)
  Rules.isValidPath(Validator)
  Rules.isValidProfileName(Validator)
  Rules.isValidProfileNameAddKorea(Validator)
  Rules.isValidSignatureMessage(Validator)
  Rules.isValidLoginId(Validator)
  Rules.isValidLoginIdA1(Validator)
  Rules.isValidAdminPasswd(Validator)
  Rules.isValidAdminPasswdCc(Validator)
  Rules.isValidEmail(Validator)
  Rules.checkExpireDate(Validator)
  Rules.checkMinLength(Validator)
  Rules.isValidEmailAndDomain(Validator)
  Rules.isValidEnglishAndNumbericChar(Validator)
  Rules.isValidcheckUrl(Validator)
  Rules.isValidVpnPasswd(Validator)
  Rules.isValidVpnPasswdCc(Validator)
  Rules.isValidServicePort(Validator)
  Rules.isValidAppSignaturePort(Validator)
  Rules.isValidIpHostName(Validator)
  Rules.isValidIpDomain(Validator)
  Rules.isValidIpv4Domain(Validator)
  Rules.checkTimeBefore(Validator)
  Rules.isValidSnmpPasswd(Validator)
  Rules.isValidSnmpPasswdCc(Validator)
  Rules.isValidIPv4NetMask(Validator)
  Rules.isValidIPv4NetMaskOne(Validator)
  Rules.isValidIPv6NetMask(Validator)
  Rules.isValidIPv6NetMaskOne(Validator)
  Rules.isValidCommunityName(Validator)
  Rules.isValidCommunityNameSecui(Validator)
  Rules.isValidLinkageServerId(Validator)
  Rules.isValidLoginIdOrMail(Validator)
  Rules.isValidUserDefinePort(Validator)
  Rules.isValidUserDefineRangePort(Validator)
  Rules.isValidSpace(Validator)
  Rules.isOnlyNumber(Validator)
  Rules.isOnlyNumberHyphen(Validator)
  Rules.isValidPhone(Validator)
  Rules.isValidPhone2(Validator)
  Rules.isValidVSName(Validator)
  Rules.isValidDNSDomain(Validator)
  Rules.isValidWellKnownWord(Validator)
  Rules.isValidWellKnownWordCommunity(Validator)
  Rules.isValidCertificateName(Validator)
  Rules.isValidSslCertificateName(Validator)
  Rules.isValidReservedWord(Validator)
  Rules.isValidTimeReservedWord(Validator)
  Rules.isValidDdnsHostName(Validator)
  Rules.isValidDdnsHostId(Validator)
  Rules.isValidDhcpMacHostName(Validator)
  Rules.isValidProtocolName(Validator)
  Rules.isValidOnlyNumberProtocolName(Validator)
  Rules.isValidRangePort(Validator)
  Rules.isValidVlanId(Validator)
  Rules.isValidDeviceAlias(Validator)
  Rules.isValidcheckVpnGroupUrl(Validator)
  Rules.isValidVpnId(Validator)
  Rules.isValidVpnId32(Validator)
  Rules.isValidVpnId48(Validator)
  Rules.isValidEquipmentHostName(Validator)
  Rules.isValidDnsHostEmail(Validator)
  Rules.isValidDomain(Validator)
  Rules.isValidRoutPolicyTableName(Validator)
  Rules.isValidVriRoutPolicyTableName(Validator)
  Rules.isValidStringUserName(Validator)
  Rules.isValidVsiReservedWord(Validator)
  Rules.isValidUserDomain(Validator)
  Rules.isValidBackupPasswd(Validator)
  Rules.isValidIpv46Domain(Validator)
  Rules.isValidWmiId(Validator)
  Rules.isValidKorId(Validator)
  Rules.isValidVid(Validator)
  Rules.isValidLinuxId(Validator)
  Rules.isValidPPPoeIdPwd(Validator)
  Rules.isValidTenCount(Validator)
  Rules.isValidVpnIdNoKor(Validator)
  Rules.isValidVpnId32NoKor(Validator)
  Rules.isValidVpnBranchId32NoKor(Validator)
  Rules.isValidPolicyStartPort(Validator)
  Rules.isValidVsiLogDisk(Validator)
  Rules.isValidVpnNoKorAllChar(Validator)
  Rules.isValidVpnId32NoKorAllChar(Validator)
  Rules.isValidSignatureOpt(Validator)
  Rules.isValidIPv4IPv6NoNetMask(Validator)
  Rules.isValidPasswdMax32(Validator)
  Rules.isValidWindowPath(Validator)
  Rules.isValidUnixPath(Validator)
  Rules.isValidVpnIfLineNoKor(Validator)
  Rules.isValidNotSpecialIp(Validator)
  Rules.isValidAuthUserId(Validator)
  Rules.isValidTimeHHmm(Validator)
  Rules.isValidTimeHHmmss(Validator)
  Rules.isValidDate(Validator)
  Rules.isCompareValidDate(Validator)
  Rules.isValidDoubleQuotes(Validator)
  Rules.isValidComplexNumber(Validator)
  Rules.isValidComplexAbsNumber(Validator)
  Rules.isValidKor20(Validator)
  Rules.isValidComplexAbsPort(Validator)
  Rules.isIpsIpv4ValidPrefix(Validator)
  Rules.isIpsIpv6ValidPrefix(Validator)
  Rules.isValidDateTime(Validator)
  Rules.isValidDateTimeHHmmss(Validator)
  Rules.isCompareValidDateTime(Validator)
  Rules.isCompareValidDateTimeHHmmss(Validator)
  Rules.isValidVpnDoubleQuotes(Validator)
  Rules.isValidNumberRange(Validator)
  Rules.isValidRouteMapName(Validator)
  Rules.isValidUrlSpecialChar(Validator)
  Rules.isValidOtpParamsName(Validator)
  Rules.isValidTagName(Validator)
  Rules.isValidProAlgrKey(Validator)

  // TAMS
  Rules.isValidLoginIdA2(Validator)
  Rules.isValidBondName(Validator)
  Rules.isValidSpaceNameMin4(Validator)
  Rules.isValidSpaceNameMin4andNotNull(Validator)
  Rules.isValidNameLenth(Validator)
  Rules.isValidIPall(Validator)
  Rules.isValidSpecialChar(Validator)
  Rules.isValidTamsSpecialChar(Validator)
  Rules.isValidTamsSpecialChar2(Validator)
  Rules.isValidDirSpecialChar(Validator)
  Rules.isValidSnortSpecialChar(Validator)
  Rules.isValidIPv4MaskRange(Validator)
  Rules.isValidEngNumKor(Validator)
  Rules.isEventPort(Validator)
  Rules.isIpsIpv4ValidPrefix(Validator)
  Rules.isIpsIpv6ValidPrefix(Validator)
  Rules.isValidVlan(Validator)
  Rules.isValidNaturalNumbers(Validator)
  Rules.isValidCsConfirm(Validator)
  Rules.isValidLowerCaseAndNumeric(Validator)
  Rules.isValidComplexPwd(Validator)
  Rules.isValidComplexPwd2(Validator)
  Rules.isValidCharacter(Validator)
  Rules.isValidMailComplexPwd(Validator)
  Rules.isValidNotChainKeyboard(Validator)
  Rules.isValidSimilarIdPw(Validator)
}

export default setCustomRule
